export default [
  {
    key: 'name',
    label: '支店名',
    style: {
    }
  }, 
  {
    key: 'code',
    label: '支店コード',
    style: {
    }
  },
  {
    key: 'actions',
    label: '',
    style: {
    }
  },
];


// WEBPACK FOOTER //
// ./src/containers/master/branchOffice/listHeader.js